import {Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {UserEditDialogComponent} from './user-edit-dialog/user-edit-dialog.component';
import {upperCaseValue, getValue} from 'projects/core/src/public-api';
import {environment} from 'projects/desktop/src/environments/environment';
import moment from 'moment';
import {MatDialog} from '@angular/material/dialog';
import {LocalStorage} from 'ngx-webstorage';
import {Table} from 'primeng/table';
import {UsersService} from '../../data/users.service';
import {distinctUntilChanged, debounceTime, takeUntil} from 'rxjs/operators';
import {DeviceDetectorService} from 'ngx-device-detector';
import {UserRole} from 'projects/core/src/lib/login/data/user-role';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {Subject, timer} from 'rxjs';


class TableColumnDef {
  field: string
  header: string
  type?: 'Date' | 'number' | 'user'
  renderer?: any
}

@Component({
  selector: 'app-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.scss'],
  providers: [DeviceDetectorService]
})
@RxJSUnsubscribe
export class UsersPageComponent implements OnInit, OnDestroy, AfterViewInit, RxJSUnsubscribable {
  users: User[];
  searchedUsers: User[];

  cols: TableColumnDef[];

  loadingUsers = true;

  usersPerPage = 50;
  totalElements: number;

  colsForSearch = [];

  @ViewChild('ut', {static: true})
  usersTable: Table;

  @LocalStorage()
  showInActiveUsers: boolean;

  @LocalStorage()
  usersString: string[];

  first: number;
  rows: number;

  isMobile: boolean;

  rolesNum = 0;
  searchValue: string;

  constructor(
    protected deviceDetector: DeviceDetectorService,
    protected el: ElementRef,
    protected dialog: MatDialog,
    protected userService: UserService,
    protected usersService: UsersService
  ) {
  }

  ngOnInit() {
    this.isMobile = this.deviceDetector.isMobile();


    this.usersService.getRoles().subscribe(roles => {
      this.rolesNum = roles.length;

      if (!this.usersString) {
        this.usersString = roles.map(role => role.name);
      }
    })
  }

  ngAfterViewInit() {
    timer(1).subscribe(() => {
      this.usersPerPage = Math.trunc((this.el.nativeElement.offsetHeight - (environment.bottomOfSet * 2)) / 35);

      if (!this.usersPerPage) {
        this.usersPerPage = 25
      }

      this.cols = [
        {field: 'name', header: 'Name', renderer: upperCaseValue}
      ];

      if (!this.isMobile) {
        this.cols.push(
          {field: 'roles', header: 'Roles'},
          {field: 'phone', header: 'Phone'},
          {field: 'email', header: 'E-Mail'})
      }

      this.countCols();
      this.loadNewUsers(0, this.usersPerPage);
    })
  }


  countCols() {
    this.cols.forEach(col => {
      this.colsForSearch.push(col.field)
    })
  }

  openUser(event: any) {
    this.openUserWindow(event.data)
  }

  loadNewUsersLazy(event: any) {
    this.loadNewUsers(event.first, event.rows);
  }

  loadNewUsers(start: number, limit: number) {
    this.first = start;
    this.rows = limit;

    if (this.usersString) {
      this.loadingUsers = true;

      let serviceString = this.usersService.getUsersByRoles(start / limit, limit, this.usersString.join(','), !this.showInActiveUsers)

      if (this.rolesNum === this.usersString.length && this.showInActiveUsers) {
        serviceString = this.usersService.getAllUsers(start / limit, limit)
      }

      serviceString
        .pipe(
          takeUntil(this.getUnsubFromAllSubs()),
          distinctUntilChanged(),
          debounceTime(200)
        ).subscribe(users => {
        this.users = users.content
        this.totalElements = users.totalElements;
        this.loadingUsers = false;
      })

    }
  }

  openUserFromSearchBar(user: User) {
    this.searchValue = ''
    this.openUserWindow(user)
  }

  openUserWindow(user: User) {
    const dialogRef = this.dialog.open(UserEditDialogComponent, {
      data: {
        user,
        buttonLabel: 'Save'
      },
      panelClass: 'user-edit-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadNewUsers(this.first, this.rows);
    });
  }

  getFieldData(rowData: any, col: TableColumnDef) {
    let value = getValue(rowData, col.field)
    if (col.type === 'Date') {
      value = moment(value).format('ll');
    } else if (col.type === 'number') {
      value = Math.round(value * 100) / 100
    }

    if (col.field === 'roles') {
      const roles = value as UserRole[];
      value = roles.map(role => role.name).join(', ')
    }

    if (col.renderer) {
      value = col.renderer(value)
    }
    // if col has renderer, then apply this renderer to value

    return value
  }

  updateRoles(rolesString: string[]) {
    this.usersString = rolesString;

    this.loadNewUsers(this.first, this.rows);
  }

  toggleUsers() {
    this.loadNewUsers(this.first, this.rows);
  }

  createNewUser() {
    const dialogRef = this.dialog.open(UserEditDialogComponent, {
      data: {
        user: {},
        buttonLabel: 'Add'
      },
      panelClass: 'new-user-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadNewUsers(this.first, this.rows);
    });
  }

  ngOnDestroy(): void {

  }

  filterUsers(event) {
    const query = event.query;

    this.usersService
      .searchUsers(query, true)
      .subscribe(users => {
        this.searchedUsers = users
      })
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
